export const TableStatusConstants = {
  /**
   * 空闲
   */
  TABLE_FREE: 1,
  /**
   * 待下单
   */
  TABLE_WAIT_ORDER: 2,
  /**
   * 使用中
   */
  TABLE_USING: 3,
  /**
   * 已预订 - 前端判断得来的
   */
  TABLE_BOOKED: 4,
  /**
   * 维修
   */
  TABLE_REPAIR: 5,
  /**
   * 暂停
   */
  TABLE_PAUSE: 6,
  /**
   * 反结账
   */
  TABLE_REVERSE: 7,
} as const

export type TableStatusType = typeof TableStatusConstants[keyof typeof TableStatusConstants]
